
import { defineComponent } from "vue";
import axios from "axios";
import store from "@/store";
export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "dashboard",
  data() {
    return {
      role: "" as string,
    first_name: "" as string,
    last_name: "" as string,
    isMenuOpen: false,
    };
  },
  methods: {
    logout() {
      axios
        .get("users/logout")
        .then(() => {
          store.commit("Logout");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchuser() {
      this.role = localStorage.getItem("role") ?? "" as string;
      this.first_name = localStorage.getItem("firstname") ?? "" as string;
      this.last_name = localStorage.getItem("lastname") ?? "" as string;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
  mounted() {
    this.fetchuser();
  },
});
